import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import frequency from './frequency/reducers';
import i18n from './i18n/reducers/i18n';
import { ftux, modals, welcomeMat } from './common/reducers';

export default combineReducers({
  routing: routerReducer,
  frequency,
  modals,
  welcomeMat,
  ftux,
  i18n
});
